import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';

const IcoIdBack40 = ({ 'aria-label': ariaLabel, className, color }: IconProps) => {
  const iconColor = getIconColor(color);
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
      className={className}
      role="img"
      data-colored={false}
    >
      <g>
        <rect x={5} y={5} width={30} height={30} rx={3.75} stroke={iconColor} strokeWidth={3.333} />
        <rect x={11.111} y={10} width={17.778} height={2.5} rx={1.25} fill={iconColor} />
        <rect x={16.444} y={14.444} width={12.444} height={2.5} rx={1.25} fill={iconColor} />
        <path
          d="M11.1113 26.1904C11.1113 25.3489 11.9957 24.6666 13.0866 24.6666H26.9138C28.0047 24.6666 28.8891 25.3489 28.8891 26.1904V28.4761C28.8891 29.3177 28.0047 30 26.9138 30H13.0866C11.9957 30 11.1113 29.3177 11.1113 28.4761V26.1904Z"
          fill={iconColor}
        />
      </g>
      <defs />
    </svg>
  );
};
export default IcoIdBack40;
